import config from 'config/config';

let googleAuth = {};
let googleIsInit = false;

export const initGoogleSignup = (googReady) => {
  if (!!googleIsInit) {
    googReady();
    return;
  }
  var fjs = document.getElementsByTagName('script')[0];
  var js = document.createElement('script');
  js.src = 'https://apis.google.com/js/api.js';
  fjs.parentNode.insertBefore(js, fjs);

  js.onload = () => {
    const gapi = window.gapi;
    gapi.load('client:auth2', () => {
      gapi.auth2.init({
        'client_id': config.google.clientId,
        scope: 'profile',
      }).then((apiFullfilled) => {
        googleAuth = apiFullfilled;
        googReady();
        googleIsInit = true;
      });
    });
  };
};

export const googleSignupClick = (validateLoginData) => {
  if (!googleAuth) {
    return;
  }
  googleAuth.signIn().then(() => {
    const user = googleAuth.currentUser.get();
    const profile = user.getBasicProfile();
    const googLoginData = {
      accessToken: user.getAuthResponse().id_token,
      googleUserId: profile.getId(),
      staySignedIn: true,
      email: profile.getEmail(),
      isVerified: true,
    };
    validateLoginData(googLoginData);
  }, (error) => {/* this handles the uncaught error from google if the user cancels */});
};



// WEBPACK FOOTER //
// ./src/utils/google.js